module.exports = __webpack_public_path__ + "static/media/Water.fd978d36.png";